import { render, staticRenderFns } from "./information.dropdown.vue?vue&type=template&id=775c65cc&"
import script from "./information.dropdown.vue?vue&type=script&lang=js&"
export * from "./information.dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports